import {
    IBaseUser,
    IExtendedBasicUser,
    IServerUser,
    IServerUserMailbox,
    IUser,
    IUserMailbox,
} from '../../../common';

const convertUserMailboxFromServer = (
    serverMailbox: IServerUserMailbox
): IUserMailbox => ({
    id: serverMailbox.id,
    emailAddress: serverMailbox.email_address,
    createdAt: serverMailbox.created_at,
    name: serverMailbox.name,
    provider: serverMailbox.provider,
});

export const getUserFromServerUserFormat = (serverUser: IServerUser): IUser => {
    const company = serverUser.company;
    return {
        id: serverUser.id,
        firstName: serverUser.first_name,
        lastName: serverUser.last_name,
        email: serverUser.email,
        createdAt: serverUser.created_at,
        updatedAt: serverUser.updated_at,
        gender: serverUser.gender,
        birthDate: serverUser.birth_date,
        phone: serverUser.phone,
        address: serverUser.address,
        jobTitle: serverUser.job_title || '',
        profilePicture: serverUser.image,
        company: company
            ? {
                  id: company.id,
                  name: company.name,
                  key: company.key,
                  description: company.description,
                  defaultLanguage: company.default_language,
                  rootAdmin: company.root_admin,
                  companyLogoUrl: company.company_logo_url,
                  addressText: company.address_text,
                  url: company.url,
                  phone: company.phone,
              }
            : undefined,
        toolsCompanyProfiles: serverUser.tool_company_profiles || [],
        socketChannels: serverUser.socket_channels,
        userMailboxes: (serverUser.mailboxes || []).map(
            convertUserMailboxFromServer
        ),
    };
};

export const getBaseUserFromServerFormat = (user: IServerUser): IBaseUser => {
    return {
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
        profilePicture: user.image,
    };
};
export const getBaseUsersFromServerUsersFormat = (
    serverUsers: Array<IServerUser>
): Array<IBaseUser> => {
    return serverUsers.map((user) => getBaseUserFromServerFormat(user));
};

export const getExtendedBasicUserFromServerFormat = (
    user: IServerUser
): IExtendedBasicUser => {
    return {
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
        profilePicture: user.image,
        phone: user.phone,
    };
};
